document.addEventListener("DOMContentLoaded", function () {
  // Select the alt-text overlay div by its ID
  var altTextOverlay = document.getElementById("alt-text-overlay");

  // Select the media viewer list
  var mediaViewer = document.querySelector(".media-viewer");

  // Get the product name (ensure this is set in the DOM or fetched dynamically)
  var productName = document.querySelector(".product-title").textContent.trim(); // Adjust the selector if necessary

  // Function to update the visibility of the alt-text overlay
  function updateAltText(currentImage) {
    // Ensure the image exists and has alt text
    if (currentImage && currentImage.alt && currentImage.alt.trim() !== "") {
      var altText = currentImage.alt.trim();

      // Check if the alt text matches the product name or is empty
      if (altText === productName || altText === "") {
        altTextOverlay.style.display = "none"; // Hide the entire overlay
      } else {
        altTextOverlay.textContent = altText; // Update the text
        altTextOverlay.style.display = "block"; // Show the overlay
      }
    } else {
      altTextOverlay.style.display = "none"; // Hide the overlay if no valid alt text
    }
  }

  // Set up IntersectionObserver to detect when the image is in view
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // When an image becomes visible, update the alt text and visibility
          var visibleImage = entry.target;
          updateAltText(visibleImage);
        }
      });
    },
    {
      threshold: 0.5, // Adjust as necessary to determine when image is "visible enough"
    }
  );

  // Observe each image in the media viewer
  mediaViewer.querySelectorAll("img").forEach(function (image) {
    observer.observe(image); // Start observing each image
  });
});